import {request} from '@/helpers/apiClient'
import {TIER_CONFIG} from '@/utils/constants/apiConfig/tierConfig'
import {transformTierDetailsResponse} from '@/utils/localeTransformer'

export const TIER_QUERY_KEY = {
  ACTIVE_TIERS: 'active-tiers',
  TIER_OPTIONS: 'tier-options',
}
export const getTierStores = async (tierID, queryParams, page, paginationSize) =>
  request(TIER_CONFIG.TIER_STORES(tierID, queryParams, page, paginationSize))
export const fetchTiers = async queryParams => request(TIER_CONFIG.TIERS, {}, queryParams)
export const getTierDetails = async (tierID, queryParams) => {
  const response = await request(TIER_CONFIG.GET_TIER_DETAILS(tierID), {}, queryParams)
  return transformTierDetailsResponse(response)
}
export const getTierOptions = async () => request(TIER_CONFIG.CREATE_TIER_OPTIONS)
export const getFilteredStoresByStore = async (tierID, searchArr, page, limit) =>
  request(TIER_CONFIG.GET_FILTERED_STORES_BY_STOREID(tierID, searchArr, page, limit))
export const getFilteredStoresByDate = async (tierID, searchArr, page, limit) =>
  request(TIER_CONFIG.GET_FILTERED_STORES_BY_DATE(tierID, searchArr, page, limit))
export const createTier = async (tierData, isDraft = false) => {
  const status = isDraft ? 'DRAFT' : 'PUBLISHED'
  const payload = {
    ...tierData,
    status,
  }

  return request(TIER_CONFIG.CREATE_UPDATE_TIER, {data: payload})
}
export const postMoveStores = async (tierID, requestBody) =>
  request(TIER_CONFIG.MOVE_STORES(tierID), {data: requestBody})
export const postUploadStores = async payload => request(TIER_CONFIG.UPLOAD_TIER_STORES, {data: payload})
